import { createDrawingObject, replaceLastPoint } from "../shared";
const RotatedRectangle = {
    name: "rotatedRectangle",
    createDraft: (startPoint) => createDrawingObject("rotatedRectangle", [startPoint, startPoint]),
    updateDraft: (draft, nextPoint) => replaceLastPoint(draft, nextPoint),
    render: () => undefined,
};
export default RotatedRectangle;
